import React, {useState, useEffect, useRef} from "react";
import Checkbox from "../../../../components/Checkbox";
import Play from "../../../../components/Play";

const getMaxPlays = (data) => {
  if (!data) return 1;

  return Number(
    data.audio_max_plays ||
    data.audioMaxPlays ||
    data.max_audio_plays ||
    data.maxAudioPlays ||
    1
  );
}

const hasMaxPlays = (data) => {
  if (!data) return false;

  return (
    data.audio_max_plays !== undefined ||
    data.audioMaxPlays !== undefined ||
    data.max_audio_plays !== undefined ||
    data.maxAudioPlays !== undefined
  );
}

const SurveyCheckboxAudioItem = (props) => {
  const audioRef = useRef(null);
  const { questionData } = props;
  const [played, setPlayed] = useState(false);
  const [remainingPlays, setRemainingPlays] = useState(1);
  const [maxPlays, setMaxPlays] = useState(1);
  const [isStartingAudio, setIsStartingAudio] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  
  useEffect(() => {
    const alreadyPlayed = questionData && (questionData.played === true || questionData.played === "true");
    const audioMaxPlays = getMaxPlays(questionData);
    const audioPlaysLeft = questionData && questionData.audio_plays_left !== undefined
      ? Number(questionData.audio_plays_left)
      : (alreadyPlayed ? 0 : audioMaxPlays);
    setPlayed(alreadyPlayed)
    setRemainingPlays(audioPlaysLeft)
    setMaxPlays(audioMaxPlays)
    setIsStartingAudio(false)
    setIsAudioPlaying(false)

    setTimeout(() => {
      if (audioRef.current) {
        const audio = audioRef.current;
        audio.pause();
        audio.currentTime = 0;
        audio.load();
        setPlayed(alreadyPlayed)
        setRemainingPlays(audioPlaysLeft)
        setMaxPlays(audioMaxPlays)
        setIsStartingAudio(false)
        setIsAudioPlaying(false)
      }  
    }, 1000)
    
  }, [questionData]);


  const _handleCheckbox = (index, data) => {
    return props.handleClick({ [index]: data });
  };


  const _isSelected = (index) => {
    return Object.keys(props.selectedItems).includes(index.toString())  
  }

  const playedCount = Math.min(Math.max(maxPlays - remainingPlays, 0), maxPlays);

  const updateAudioPlays = (response) => {
    if (hasMaxPlays(response)) {
      setMaxPlays(getMaxPlays(response));
    }

    if (response && response.audio_plays_left !== undefined) {
      const audioPlaysLeft = Number(response.audio_plays_left);
      setRemainingPlays(audioPlaysLeft);
      setPlayed(response.played === true || audioPlaysLeft <= 0);
    } else {
      const audioPlaysLeft = Math.max(remainingPlays - 1, 0);
      setRemainingPlays(audioPlaysLeft);
      setPlayed(audioPlaysLeft <= 0);
    }
  }

  const startPlay = async () => {
    try{
      if (remainingPlays <= 0) {
        setPlayed(true)
        return false;
      }

      const audio = audioRef.current;
      if (!audio || isStartingAudio || (!audio.paused && !audio.ended)) {
        return false;
      }

      if (audio.ended || (audio.duration && audio.currentTime >= audio.duration)) {
        audio.currentTime = 0;
      }

      setIsStartingAudio(true);
      const playPromise = audio.play();
      if (playPromise && playPromise.then) {
        await playPromise;
      }

      setIsAudioPlaying(true);
      props.playedAudio((response) => {
        updateAudioPlays(response);
      });
      setIsStartingAudio(false);
    }catch(e){
      setIsStartingAudio(false);
      setIsAudioPlaying(false);
    }
    
  }
  return (
    <>
      {questionData.item_context && (
        <p className="c-item-format-style-12__item-context">{questionData.item_context}</p>
      )}
      {questionData.img_context && (
        <>
          <audio
            ref={audioRef}
            controls
            style={{display: 'none'}}
            onEnded={() => {
              setIsAudioPlaying(false);
              if (audioRef.current) audioRef.current.currentTime = 0;
            }}
            onPause={() => setIsAudioPlaying(false)}
            onPlaying={() => setIsAudioPlaying(true)}
          >
            <source src={questionData.img_context} type="audio/mpeg" />
              Your browser does not support the audio element.
          </audio>
          
        </>
      )}
      { !played && remainingPlays > 0 && questionData.img_context &&
        <div style={{textAlign: 'center', marginBottom: 10, display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
          <button onClick={() => startPlay()} disabled={isStartingAudio || isAudioPlaying}>
            <Play width="48" height="48" />
          </button>
          <small>Play</small>
          <small>{playedCount}/{maxPlays} reproducciones</small>
        </div>
      }
      {
        (played || !questionData.img_context) &&
          <div style={{textAlign: 'center', marginBottom: 10, display: 'flex', alignItems: 'center', flexDirection: 'column', justifySelf: 'center'}}>
            <div style={{ opacity: 0.3 }}>
              <Play width="48" height="48" />
            </div>
            <small>Played</small>
            {questionData.img_context && <small>{playedCount}/{maxPlays} reproducciones</small>}
          </div>
      }
      {questionData.title && questionData.intro_title && (
        <p className="c-item-format-style-12__item-title">{questionData.title}</p>
      )}
      <ul className="c-item-format-style-12__item-list">
        {Object.values(questionData.items).map((item, index) => {
          return (
            <li key={`${item.text}-${index}`} className="o-margin--bottom-size-s o-display--flex">
                <Checkbox 
                  // text={item.name || item.text}
                  text={''}
                  value={item.value}
                  onClick={() => _handleCheckbox(index, item)}
                  checked={_isSelected(index)}
                  className="o-display--flex"
                  groupClass="c-checkbox__tick-illustration-color--primary"
                  // correct={_isCorrect()}
                  item_format_style={props.item_format_style}
                />
                {item && item.img && (<img src={item.img} alt={item.text} className="c-item-format-style-12__item-image" />)}
                {item && item.text && (<p className="c-item-format-style-12__item-text">{item.text}</p>)}
            </li>
          )
        })}
      </ul>
    </>
  )
};

export default SurveyCheckboxAudioItem;
